
import { Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'mce-info-message',
    imports: [MatCardModule, MatIconModule],
    templateUrl: './info-message.component.html',
})
export class InfoMessageComponent {

  type = input<'success' | 'warning' | 'error' | 'information'>();

  bgClass = computed<string>(() => {
    switch (this.type()) {
      case 'success': return 'bg-success';
      case 'warning': return 'bg-warning';
      case 'error': return 'bg-error';
      default: return 'bg-information';
    }
  });



}
